// Decompression is always single-file (one download at a time), so the full
// WorkerPool machinery (ID map, queue, concurrency) is unnecessary.
// A bare singleton worker with one pending resolve slot is sufficient.

let worker: Worker | null = null;
let pendingResolve: ((result: Uint8Array | null) => void) | null = null;

function getWorker(): Worker {
  if (!worker) {
    worker = new Worker(
      new URL('./decompressionWorker.ts', import.meta.url),
      { type: 'module' }
    );
    worker.onmessage = ({ data }: MessageEvent<{ buffer: ArrayBuffer | null }>) => {
      const resolve = pendingResolve;
      pendingResolve = null;
      resolve?.(data.buffer ? new Uint8Array(data.buffer) : null);
    };
    worker.onerror = (e) => {
      console.error('[decompressionPool] worker error:', e);
      const resolve = pendingResolve;
      pendingResolve = null;
      resolve?.(null);
      worker = null;
    };
  }
  return worker;
}

export const decompressionPool = {
  decompress(data: Uint8Array): Promise<Uint8Array | null> {
    return new Promise((resolve) => {
      pendingResolve = resolve;
      // Slice to ensure byteOffset=0 before transfer.
      const buffer = data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength);
      getWorker().postMessage({ buffer }, [buffer]);

    });
  },

  terminate() {
    worker?.terminate();
    worker = null;
    pendingResolve = null;
  }
};
